module.exports = __webpack_public_path__ + "static/life-regular-c59a21ccb950e5fe15f9f65b78d5a9d8.woff2";